import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Icon } from '@qga/roo-ui/components';

const RoomTypeDisplayMeta = React.memo(({ maxOccupantCount, roomSize = '', bedConfiguration = '' }) => {
  if (!maxOccupantCount) return null;

  return (
    <Flex alignItems="center" pb={2} data-testid="room-display-meta">
      <Icon name="group" size={16} mr={2} />
      <Text fontSize="base" color="greys.charcoal" data-testid="room-display-text">
        Sleeps {maxOccupantCount}
        {roomSize && ` • ${roomSize}`}
        {bedConfiguration && ` • ${bedConfiguration}`}
      </Text>
    </Flex>
  );
});

RoomTypeDisplayMeta.displayName = 'RoomTypeDisplayMeta';

RoomTypeDisplayMeta.propTypes = {
  maxOccupantCount: PropTypes.number,
  roomSize: PropTypes.string,
  bedConfiguration: PropTypes.string,
};

export default RoomTypeDisplayMeta;
